import { useEffect } from 'react';
import { useViewer, useViewerStoreHandle } from '../store/context';

const DEBOUNCE_MS = 200;

/**
 * Re-renders the edit buffer into the live preview, debounced, through the
 * store's `previewBuffer` (which runs the shared renderer pipeline). No-op when
 * not editing (buffer is null).
 */
export function useEditorPreview(): void {
  const store = useViewerStoreHandle();
  const editBuffer = useViewer((s) => s.editBuffer);

  useEffect(() => {
    if (editBuffer === null) return;
    const id = setTimeout(() => {
      void store.getState().previewBuffer(editBuffer);
    }, DEBOUNCE_MS);
    return () => {
      clearTimeout(id);
    };
  }, [editBuffer, store]);
}
